import { Component } from 'react';
import Truncate from 'react-truncate';
import { history } from '../../../../store';

class BrandCarouselItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      itemClassName: ''
    };
  }

  componentDidMount() {
    this.calculateFade();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isScrolled !== this.props.isScrolled) {
      this.calculateFade();
    }
  }

  getRef = (instance) => {
    this.ref = instance;
  }

  calculateFade = () => {
    if (this.ref) {
      const {
        width, left
      } = this.ref.getBoundingClientRect();
      const { outerWidth } = window;
      const halfWidth = (width / 2);
      const center = left + halfWidth;

      if (center + halfWidth <= outerWidth && center - halfWidth >= 0) {
        this.setState({ itemClassName: 'overlay-visible' });
      } else if (center + halfWidth < outerWidth || center - halfWidth > 0) {
        this.setState({ itemClassName: 'overlay-partly-visible' });
      }
    }
  }

  render() {
    const { name, image } = this.props;
    const { itemClassName } = this.state;
    const isMobileScreen = window.innerWidth <= 768;

    return (
      <div>
        <div ref={this.getRef} className="carousel-item">
          <a
            href={`/brands?brand=${name}`}
            style={{ opacity: isMobileScreen ? 1 : 0 }}
            className={`overlay ${itemClassName}`}
          >
            <Truncate lines={2} ellipsis={<span>...</span>}>
              {name}
            </Truncate>
          </a>
          <img src={image} alt={name}/>
        </div>
        {!isMobileScreen && (
          <div
            className="carousel-item-title"
            onClick={() => {
              history.push(`/brands?brand=${name}`);
            }}
          >
            {name}
          </div>
        )}
      </div>
    );
  }
}

export default BrandCarouselItem;
